import { render, staticRenderFns } from "./RelatedCategoriesInput.vue?vue&type=template&id=2412fb02&scoped=true&"
import script from "./RelatedCategoriesInput.vue?vue&type=script&lang=js&"
export * from "./RelatedCategoriesInput.vue?vue&type=script&lang=js&"
import style0 from "./RelatedCategoriesInput.vue?vue&type=style&index=0&id=2412fb02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2412fb02",
  null
  
)

export default component.exports